import { chakra } from '@plurall/elo-v3';

import { schoolSelectorRootRecipe } from './schoolSelector.recipe';

export const SchoolSelectorRootFactory = chakra('div', schoolSelectorRootRecipe);
